import React, {FC} from "react"
import FormattedMessage from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {Body, H2} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import styled, {css} from "styled-components"
import {minWidthMedia} from "@irati/ui/src/global/media"

interface Step {
  title?: string
  subTitle?: string
  image?: string
}

interface Props {
  itemsPerRow: number
  items: Step[]
}

const StepsGrid: FC<Props> = ({itemsPerRow, items}) => {
  const theme = useTheme()

  return (
    <Wrapper flush bgColor={theme.colors.primary2}>
      <Content>
        <H2 color={theme.colors.greys.white}>
          <FormattedMessage id="annualLeavePurchase.landing.steps.title" />
        </H2>
        <GridContainer itemsPerRow={itemsPerRow}>
          {items.map((item, index) => (
            <Flex key={index} direction="column" alignItems="center" gap={1.5}>
              <img src={item.image} alt={item.image} />
              <H2 color={theme.colors.greys.white}>
                <FormattedMessage id={item.title} />
              </H2>
              <Body color={theme.colors.greys.white} textAlign="center">
                <FormattedMessage id={item.subTitle} />
              </Body>
            </Flex>
          ))}
        </GridContainer>
      </Content>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${({theme}) => theme.colors.primary2};
`

const GridContainer = styled.div<{itemsPerRow: number}>`
  display: grid;
  gap: 16px;
  grid-template-columns: none;
  ${minWidthMedia.tablet`
    grid-template-columns: repeat(${({itemsPerRow}) => itemsPerRow}, minmax(0, 1fr));
  `}
`

const Content = styled(Flex)`
  ${({theme}) => css`
    flex-direction: column;
    align-items: center;
    padding: ${theme.spacing.two};
    gap: ${theme.spacing.three};
    ${minWidthMedia.tablet`
      padding: ${theme.spacing.six} 5%;
    `}
  `}
`

export default StepsGrid
